const GroupName = ({ name }: { name: string }) => (
  <div className="name-box">{name}</div>
);
export default GroupName;
